import { Form, message } from 'antd';
import TcDevider from 'components/UI/Devider/TcDevider';
import LocationPicker from 'components/UI/Map/LocationPicker';
import TcCoverLoading from 'components/UI/TcLoading/TcCoverLoading';
import TcButton from 'components/UI/button/TcButton';
import TcCard from 'components/UI/card/TcCard';
import TcForm from 'components/UI/form/TcForm';
import endpointUrls from 'global/Constants/endpointUrls';
import routes from 'global/Constants/routes';
import addressModel, { peopleAddress } from 'global/Models/addressModel';
import { IBackendGetGeneric } from 'global/Models/globalModels';
import { convertFormValuesToEnglishNumber } from 'global/default';
import { handleApiThenGeneric } from 'global/helperFunctions/handleApiThen';
import { localApiCatcher } from 'global/helperFunctions/localApiCatcher';
import { mapIrGetAddressFromLatLng } from 'global/helperFunctions/mapIrFunctions';
import ApiService, { errorResponse } from 'global/utils/ApiService';
import { FC, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RootState, store } from 'redux/store';

interface IPeopleAddress {
  peopleAddressTypeId: 1 | 2;
  getAddressAfterCreate?: (_address: peopleAddress) => void;
  noBack?: boolean;
}

const names = { 1: 'فرستنده', 2: 'گیرنده' };

const PeopleAddressCreate: FC<IPeopleAddress> = ({ peopleAddressTypeId, getAddressAfterCreate, noBack }) => {
  //states
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedLocation, setSelectedLocation] = useState<{ lat: number; lng: number }>();
  const userProfile = useSelector((state: RootState) => state.user.userProfile);
  const { allCitiesWithoutSearch } = useSelector((state: RootState) => state.city);
  const { map } = useSelector((state: RootState) => state.map);
  // const [map, setMap] = useState<Map>();

  //hooks
  const [form] = Form.useForm();
  const latestReverseGeocodeRequestId = useRef(0);
  const { push } = useHistory();

  //effect
  useEffect(() => {
    if (selectedLocation) {
      form.setFieldValue('longitude', selectedLocation.lng);
      form.setFieldValue('latitude', selectedLocation.lat);
      getStringAddress(selectedLocation);
    }
  }, [selectedLocation]);

  //functions
  const getStringAddress = async (location: { lat: number; lng: number }) => {
    const requestId = ++latestReverseGeocodeRequestId.current;
    const result: any = await mapIrGetAddressFromLatLng(location?.lat, location?.lng);
    if (requestId !== latestReverseGeocodeRequestId.current) return;

    if (!result) return;
    if (result.address) {
      form.setFieldValue('fullAddress', result.address);
    }
    //update CityId in form
    if (result?.city) {
      const cityList = store.getState().city.allCitiesWithoutSearch;
      if (cityList) {
        const sameCityProvinceList = cityList.filter((city) => city.title == result.city);
        const city = sameCityProvinceList.find((city) => city.provinceTitle == result.province);
        if (city) {
          form.setFieldValue('cityId', city?.id);
          form.setFieldValue('provinceId', city?.provinceId);
        }
      }
    }
  };
  const handelSubmit = async (values: any) => {
    if (peopleAddressTypeId == 1 && !selectedLocation?.lat && !selectedLocation?.lng) {
      message.warning('انتخاب طول و عرض جغرافیایی از روی نقشه اجباری است.');
    } else {
      const location = [selectedLocation?.lat, selectedLocation?.lng];
      const payload: any = {
        title: values.title,
        isDefault: values.isDefault,
        personId: userProfile?.personId,
        peopleAddressTypeId,
        address: {
          fullAddress: values.fullAddress,
          postalCode: values.postalCode,
          latitude: location ? location[0] : null,
          longitude: location ? location[1] : null,
          cityId: values.cityId,
          provinceId: values.provinceId,
          plaque: values.plaque,
          unit: values.unit,
          floor: values.floor,
          description: values.description,
        },
      };
      setLoading(true);
      await ApiService.post(endpointUrls.addressCreate, payload)
        .then((res: IBackendGetGeneric<peopleAddress>) =>
          handleApiThenGeneric<IBackendGetGeneric<peopleAddress>, peopleAddress>({
            res,
            notifFail: true,
            notifSuccess: true,
            onSuccessData: (data) => {
              getAddressAfterCreate && getAddressAfterCreate(data);
              !getAddressAfterCreate && push(peopleAddressTypeId === 1 ? routes.senderAddress.path : routes.recieverAddress.path);
            },
          })
        )
        .catch(() => localApiCatcher(errorResponse));
      setLoading(false);
    }
  };
  const handleChange = (value: any, values: any) => {
    convertFormValuesToEnglishNumber(value, values, ['postalCode', 'plaque', 'unit', 'floor'], form, true);
    if (value.cityId && allCitiesWithoutSearch) {
      const city = allCitiesWithoutSearch.find((city) => city.id === value.cityId);

      //when city change unselect pin
      if (value.cityId) {
        setSelectedLocation(undefined);
      }

      if (map && city?.latitude && city?.longitude) {
        map.flyTo([city.latitude, city.longitude], 11);
      }
    }
  };

  return (
    <TcCard title={'ثبت آدرس ' + names[peopleAddressTypeId]} back={noBack ? undefined : peopleAddressTypeId === 1 ? routes.senderAddress.path : routes.recieverAddress.path}>
      <TcForm form={form} onFinish={handelSubmit} onValuesChange={handleChange}>
        <div className='flex flex-col gap-4 lg:flex-row'>
          <div className='w-full'>{addressModel.inputs()}</div>
          <div className='w-full'>
            <TcDevider className='mt-0'> انتخاب نشانی بر روی نقشه</TcDevider>
            <LocationPicker selectedLocation={selectedLocation} setSelectedLocation={setSelectedLocation} />
          </div>
        </div>

        <div className='flex justify-end mt-6'>
          <TcButton type='primary' htmlType='submit'>
            ثبت
          </TcButton>
        </div>
      </TcForm>
      {loading && <TcCoverLoading />}
    </TcCard>
  );
};

export default PeopleAddressCreate;
